import auth from '@udacity/ureact-hoth';

/** Udacity user id allowed to receive full Session Replay sampling in Amplitude. */
const INTERNAL_TESTER_USER_ID = '0dac81d3-9a7a-4ff0-a036-dcb09180dba4';

/**
 * Whether the given (or currently authenticated) user is an internal Session Replay tester.
 *
 * The `is_internal_tester` analytics trait derived from this flag is used in Amplitude to
 * set Session Replay session sampling to **1** (100% capture) for that user so we can
 * verify recordings end-to-end. All other users keep the default sample rate.
 *
 * @param userId - Optional user id; when omitted, uses `auth.getCurrentUserId()`.
 */
export function isInternalTester(userId?: string): boolean {
  const id = userId ?? auth.getCurrentUserId();
  return id === INTERNAL_TESTER_USER_ID;
}
